__turbopack_context__.v({
  "admin-bg-danger": "Hero-module-scss-module__twV7AW__admin-bg-danger",
  "admin-bg-info": "Hero-module-scss-module__twV7AW__admin-bg-info",
  "admin-bg-primary": "Hero-module-scss-module__twV7AW__admin-bg-primary",
  "admin-bg-secondary": "Hero-module-scss-module__twV7AW__admin-bg-secondary",
  "admin-bg-success": "Hero-module-scss-module__twV7AW__admin-bg-success",
  "admin-bg-warning": "Hero-module-scss-module__twV7AW__admin-bg-warning",
  "admin-border": "Hero-module-scss-module__twV7AW__admin-border",
  "admin-border-dark": "Hero-module-scss-module__twV7AW__admin-border-dark",
  "admin-border-light": "Hero-module-scss-module__twV7AW__admin-border-light",
  "admin-rounded": "Hero-module-scss-module__twV7AW__admin-rounded",
  "admin-rounded-full": "Hero-module-scss-module__twV7AW__admin-rounded-full",
  "admin-rounded-lg": "Hero-module-scss-module__twV7AW__admin-rounded-lg",
  "admin-rounded-md": "Hero-module-scss-module__twV7AW__admin-rounded-md",
  "admin-rounded-sm": "Hero-module-scss-module__twV7AW__admin-rounded-sm",
  "admin-shadow-lg": "Hero-module-scss-module__twV7AW__admin-shadow-lg",
  "admin-shadow-md": "Hero-module-scss-module__twV7AW__admin-shadow-md",
  "admin-shadow-sm": "Hero-module-scss-module__twV7AW__admin-shadow-sm",
  "admin-sr-only": "Hero-module-scss-module__twV7AW__admin-sr-only",
  "admin-text-light": "Hero-module-scss-module__twV7AW__admin-text-light",
  "admin-text-muted": "Hero-module-scss-module__twV7AW__admin-text-muted",
  "admin-text-primary": "Hero-module-scss-module__twV7AW__admin-text-primary",
  "admin-text-secondary": "Hero-module-scss-module__twV7AW__admin-text-secondary",
  "hero": "Hero-module-scss-module__twV7AW__hero",
  "hero__arrow": "Hero-module-scss-module__twV7AW__hero__arrow",
  "hero__container": "Hero-module-scss-module__twV7AW__hero__container",
  "hero__content": "Hero-module-scss-module__twV7AW__hero__content",
  "hero__overlay": "Hero-module-scss-module__twV7AW__hero__overlay",
  "hero__svg": "Hero-module-scss-module__twV7AW__hero__svg",
  "hero__vimeo-wrapper": "Hero-module-scss-module__twV7AW__hero__vimeo-wrapper",
});
